/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Project was published successfully" |
*
* @param {Iconik_Publish_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_success_toast = /** @type {((inputs?: Iconik_Publish_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projet publie avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Projekt wurde erfolgreich veröffentlicht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il progetto è stato pubblicato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект успешно опубликован.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El proyecto se publicó con éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目已成功发布")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトは正常に公開されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना सफलतापूर्वक प्रकाशित हुई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O projeto foi publicado com sucesso.")
	return /** @type {LocalizedString} */ ("Project was published successfully")
});